import { FormControlLabel, Radio, FormLabel, RadioGroup, FormControl, Grid } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { Documento, DynFormProps } from "../..";
import DisplayRateio from "./DisplayRateio";

export default function DynRateio({
    spec,
    extras,
}: DynRateioProps) {

    const { control, watch } = useFormContext();
    const addRateio = watch(`${spec.name}.add_rateio`) === 'true'

    const valoresSelect = [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' }
    ]

    return (
        <Grid container spacing={2} mb={2}>
            <Grid size={{xs: 12}}>
                <Controller
                    name={`${spec.name}.add_rateio`}
                    control={control}
                    rules={{ required: 'Campo obrigatório' }}
                    render={({ field }) => (
                        <FormControl fullWidth>
                            <FormLabel id={`adicionar-rateio`}>
                                Deseja dividir o valor em mais de um centro de custo?
                            </FormLabel>

                            <RadioGroup
                                {...field}
                                row
                                aria-labelledby="rateio-radio"
                            >
                                {
                                    valoresSelect.map((opcao, index) => (
                                        <FormControlLabel
                                            key={index}
                                            value={opcao.value}
                                            control={<Radio />}
                                            label={opcao.label}
                                        />
                                    ))
                                }
                            </RadioGroup>
                        </FormControl>
                    )}
                />
            </Grid>

            {
                addRateio && (
                    <Grid size={{xs: 12}}>
                        <DisplayRateio {...{ spec_name: spec.name, extras }} />
                    </Grid>
                )
            }
        </Grid>
    )
}

interface DynRateioProps extends DynFormProps {
    extras: Documento | null
}